import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  appPageTableRow: {
    position: "relative",
    borderBottom: "1px solid #eee",
    backgroundColor: "#fff"
  }
}));
